/**
 * Created by hanyong.zheng on 2018/12/28.
 */
import request from '@/utils/request'
export function getWxConfig (url) {
  const data = {
    'url': url
  }
  return request({
    url: '/getWxConfig',
    method: 'post',
    data
  })
}

export function uploadImage (params) {
  const data = {
    'userId': params.userId,
    'picType': params.picType,
    'mediaId': params.mediaId
  }
  return request({
    url: '/uploadImage',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/app.js